export const DISCIPLINA_SITUACAO_AGUARDANDO_ESCRITA = 1;
export const DISCIPLINA_SITUACAO_AGUARDANDO_TRANSPOSICAO = 2;
export const DISCIPLINA_SITUACAO_DISPONIVEL = 3;

export const badgesProps = [
  {
    color: "red",
    colorOutline: "badge-outline-danger",
    title: "Aguardando escrita pelo fornecedor",
    text: "AGUARDANDO ESCRITA",
    statusLine: "bg-gradient-danger"
  },
  {
    color: "grey darken-2",
    colorOutline: "badge-outline-secondary",
    title: "Aguardando transposição pela B42",
    text: "AGUARDANDO TRANSPOSIÇÃO",
    statusLine: "bg-gradient-secondary"
  },
  {
    color: "green",
    colorOutline: "badge-outline-success",
    title: "Disponível em whitelabel",
    text: "DISPONÍVEL",
    statusLine: "bg-gradient-success"
  }
];

export default {
  badgesProps
};
